module.exports = __webpack_public_path__ + "img/kp-zzt.4c050799.png";